module.exports = __webpack_public_path__ + "img/v_choinev.28cf562f.jpg";